<template lang="pug">
div.animated.fadeIn
  // statsbox
  div.row
    // statsbox 1
    div.col-sm-6.col-lg-3
      statsbox(category='Customers', :actions='actions1')
        | {{total.users}}
    // statsbox 2
    div.col-sm-6.col-lg-3
      statsbox(category='Interactions', color='warning', :chartData='stats.interactions')
        | {{total.interactions}}
    // statsbox 3
    div.col-sm-6.col-lg-3
      statsbox(category='Billing', color='success', :chartData='stats.revenue')
        | {{total.revenue}}
    // statsbox 4
    div.col-sm-6.col-lg-3
      statsbox(category='Compaints', color='danger', :chartData='stats.orders')
        | {{total.orders}}
  // table
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Top Conversation Topics
        // number of interactions, look at chatbase
        div.small.text-muted
          | 5 Most Interacted Topics
      div.col-sm-7.hidden-sm-down
        b-dropdown.float-right(type='button', variant='primary', v-if='userAccessLevel != "agent"')
          template(slot='button-content')
            i.icon-cloud-download
            | &nbsp;&nbsp;Export
          b-dropdown-item(@click='xlsx', type='button', variant='info')
            | Download as xlsx
          b-dropdown-item(@click='pdf', type='button', variant='info')
            | Download as pdf
        b-button.float-right(type='button', variant='primary', @click='pdf', v-else)
          i.icon-cloud-download
          | &nbsp;Export as pdf
    br
    app-table(:data='tableItems1', :label='tableFields1', small)
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Real Time Interactions
        // number of interactions, look at chatbase
        div.small.text-muted
          | 5 Most Recent Interactions
      div.col-sm-7.hidden-sm-down
        b-button.float-right(type='button', variant='primary')
          i.icon-cloud-download
    br
    app-table(:data='tableItems2', :label='tableFields2', small, rowClick)
</template>

<script>
import { ei, eip } from '@/jsonToXlsx'
import { db } from '@/firebase'
import { parseMessage } from '../filter'

const msgsRef = db.ref('newestChats')
const anaRef = db.ref('analytics')
const usersRef = db.ref('users')

// Count past 7 days based on today
var d = new Date()
var day = d.getDay()
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
var daysLocale = days.slice(day).concat(days.slice(0, day)).reverse()

export default {
  name: 'dashboard',
  data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
      usersCount: 0,
      actions1: [{ name: 'View More' }],
      // STATS IS BROKEN
      stats: () => {
        return {
          users: {
            labels: daysLocale,
            data: [0, 1, 1, 3, 3, 3, 3],
          },
          interactions: {
            labels: daysLocale,
            data: [1, 20, 9, 17, 34, 22, 54],
          },
          revenue: {
            labels: daysLocale,
            data: [1, 18, 9, 17, 34, 22, 11],
          },
          orders: {
            labels: daysLocale,
            data: [1, 18, 9, 17, 34, 22, 11],
          },
        }
      },
      total: {
        users: 3,
        interactions: 3,
        revenue: 3,
        orders: 3,
      },
      tableItems2: [],
      tableFields2: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center',
        },
        messageId: {
          label: 'Customer Name',
        },
        message: {
          label: 'Message',
        },
        timestamp: {
          label: 'Timestamp',
        },
      },
      tableItems1: [
        {
          intent: 'Get Started',
          users: 4,
          interactions: 7,
          exits: 20,
          respondTime: 1.3,
        }, {
          intent: 'Products',
          users: 2,
          interactions: 5,
          exits: 80,
          respondTime: 1.2,
        }, {
          intent: 'Wealth Solution',
          users: 1,
          interactions: 3,
          exits: 33,
          respondTime: 2.3,
        }, {
          intent: 'Market Outlook',
          users: 1,
          interactions: 7,
          exits: 71,
          respondTime: 1.4,
        }, {
          intent: 'Person Lookup',
          users: 1,
          interactions: 3,
          exits: 67,
          respondTime: 1.8,
        },
      ],
      tableFields1: {
        intent: {
          label: 'Topics',
        },
        users: {
          label: 'Users Count',
        },
        interactions: {
          label: 'Interactions Count',
        },
        exits: {
          label: 'Bounce Rate',
        },
        respondTime: {
          label: 'Average Respond Time',
        },
      },
    }
  },
  mounted: function() {
    function fullNameElseID(key, val) {
      if (val.firstName && val.lastName) {
        return val.firstName + ' ' + val.lastName
      } else if (val.name) {
        return val.name
      } else if (val.shortID) {
        return val.shortID
      } else {
        return key
      }
    }
    // Stream real time analytics
    var stats
    var total
    anaRef.on('value', (snapshot) => {
      stats = {}
      total = {}
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          stats[key] = {
            labels: daysLocale,
            data: val.data,
          }
          total[key] = (key == 'topics') ? val : val.total
        }
      )
      this.total = total
      // this.stats = stats
    })
    // Stream real time chats
    var users
    usersRef.on('value', (snapshot) => {
      users = {}
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          users[key] = val
        })
      console.log('users', users)
    })
    var msgs
    msgsRef.limitToLast(5).on('value', (snapshot) => {
      msgs = []
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          try {
            var senderID = val.senderID || val.userID
            if (users[senderID]) {
              val.username = fullNameElseID(senderID, users[senderID])
              val.url = users[senderID].profilePic || 'static/img/avatars/0.png'
              val.status = users[senderID].status || 'warning'
              val.takeover = users[senderID].takeover || false
            } else {
              val.username = fullNameElseID(senderID, users[senderID])
              val.url = 'static/img/avatars/0.png'
              val.status = 'danger'
              val.takeover = false
            }
            // Massage msg
            var cutOff = 50
            var message = parseMessage(val.message, cutOff)
            msgs.unshift({
              avatar: { url: val.url, status: val.status, tooltip: key },
              userId: senderID,
              messageId: val.username,
              timestamp: val.timestamp,
              message: message,
            })
          } catch (err) {
            console.log(err)
          }
        })
      console.log(msgs)
      this.tableItems2 = msgs
    })
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    // User Chat Link
    chatLink (value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-')
    },
    xlsx: function() {
      ei()
    },
    pdf: function() {
      eip()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue?2d2e938f